// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"c788ca5b","355":"414f1072","364":"298e1699","437":"f57ae62d","691":"f35516d5","895":"051c4323","955":"67d11264"}[chunkId] + ".css";
};